var RING_BUILDER_STEPS = [
  {
    id: "shape",
    label: "Stone Shape",
    type: "options-images",
    countStep: true,
    helpTitle: "",
    popupId: "rb-popup-diamond-guide",
    choices: [
      {
        id: 2,
        label: "Oval",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-1.webp?v=1682960285",
        default: true,
      },
      {
        id: 1,
        label: "Round Brilliant",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape.webp?v=1682960285",
        default: false,
      },
      {
        id: 3,
        label: "Cushion",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-2.webp?v=1682960285",
        default: false,
      },
      {
        id: 4,
        label: "Emerald",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-3.webp?v=1682960285",
        default: false,
      },
      {
        id: 5,
        label: "Radiant",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-radiant.png?v=1743574488",
        default: false,
      },
      {
        id: 6,
        label: "Pear",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-5.webp?v=1682960285",
        default: false,
      },
      {
        id: 8,
        label: "Marquise",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-7.webp?v=1682960285",
        default: false,
      },
      {
        id: 9,
        label: "Antique Cushion",
        image:"https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Antique_Cushion_png.png?v=1756886819",
        default: false,
      },
      {
        id: 7,
        label: "Princess",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Stone_Shape-6.webp?v=1682960285",
        default: false,
      },
      {
        id: 10,
        label: "Elongated Cushion",
        image:
          "https://cdn.shopify.com/s/files/1/0745/7102/2619/files/Stone_elongated-cushion.png?v=1766400345",
        default: false,
      }
    ], 
  },
  {
    id: "diamond",
    label: "Select your Diamond",
    type: "diamond-selector",
    countStep: true,
    popupId: "rb-popup-diamond-guide",
  },
  {
    id: "metal",
    label: "Precious Metal",
    type: "options-images",
    countStep: true,
    helpTitle: "",
    popupId: "rb-popup-metal",
    choices: [
      {
        id: 1,
        label: "Platinum",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-1.webp?v=1682960285",
        value3d: "platinum",
      },
      {
        id: 2,
        label: "18k Rose Gold",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-2.webp?v=1682960285",
        value3d: "rose-gold",
      },
      {
        id: 3,
        label: "18k Yellow Gold",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-3.webp?v=1682960285",
        value3d: "yellow-gold",
      },
      {
        id: 4,
        label: "18k White Gold",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-4.webp?v=1682960285",
        value3d: "white-gold",
      },
      {
        id: 5,
        label: "18k Rose Gold and Platinum",
        labelDisplay: "18k Rose Gold and Platinum",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-5.webp?v=1682960285",
        value3d: "platinum",
      },
      {
        id: 6,
        label: "18k Yellow Gold and Platinum",
        labelDisplay: "18k Yellow Gold and Platinum",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Metal-New-6.webp?v=1682960285",
        value3d: "platinum",
      },
    ],
  },
  {
    id: "signature",
    label: "The Signature Stone®",
    type: "options-images",
    countStep: true,
    helpTitle: "",
    popupId: "rb-popup-signature",
    choices: [
      {
        id: 1,
        label: "Red Garnet",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-1.webp?v=1682960285",
      },
      {
        id: 2,
        label: "Purple Amethyst",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-2.webp?v=1682960285",
      },
      {
        id: 3,
        label: "Aquamarine",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-3.webp?v=1682960285",
      },
      {
        id: 4,
        label: "Diamond",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-4.webp?v=1682960285",
      },
      {
        id: 5,
        label: "Tsavorite Garnet",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-5.webp?v=1682960285",
      },
      {
        id: 6,
        label: "Alexandrite",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-6.webp?v=1682960285",
      },
      {
        id: 7,
        label: "Ruby",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-7.webp?v=1682960285",
      },
      {
        id: 8,
        label: "Peridot",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-8.webp?v=1682960285",
      },
      {
        id: 9,
        label: "Blue Sapphire",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-9.webp?v=1682960285",
      },
      {
        id: 10,
        label: "Pink Sapphire",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-10.webp?v=1682960285",
      },
      {
        id: 11,
        label: "Citrine",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-11.webp?v=1682960285",
      },
      {
        id: 12,
        label: "Sky Blue Topaz",
        image:
          "https://cdn.shopify.com/s/files/1/0651/0297/1135/files/Signature-New-12.webp?v=1682960285",
      },
    ],
  },
  {
    id: "size",
    label: "Ring Size",
    type: "options-text",
    countStep: true,
    mobileSelect: true,
    popupId: "rb-popup-size",
    choices: [
      { id: 100, label: "I’ll find out (Send me a sizer after I checkout)" },
      { id: 1, label: "3.00" },
      { id: 2, label: "3.25" },
      { id: 3, label: "3.50" },
      { id: 4, label: "3.75" },
      { id: 5, label: "4.00" },
      { id: 6, label: "4.25" },
      { id: 7, label: "4.50" },
      { id: 8, label: "4.75" },
      { id: 9, label: "5.00" },
      { id: 10, label: "5.25" },
      { id: 11, label: "5.50" },
      { id: 12, label: "5.75" },
      { id: 13, label: "6.00" },
      { id: 14, label: "6.25" },
      { id: 15, label: "6.50" },
      { id: 16, label: "6.75" },
      { id: 17, label: "7.00" },
      { id: 18, label: "7.25" },
      { id: 19, label: "7.50" },
      { id: 20, label: "7.75" },
      { id: 21, label: "8.00" },
      { id: 22, label: "8.25" },
      { id: 23, label: "8.50" },
      { id: 24, label: "8.75" },
      { id: 25, label: "9.00" },
      { id: 26, label: "9.25" },
      { id: 27, label: "9.50" },
      { id: 28, label: "9.75" },
      { id: 29, label: "10.00" },
    ],
  },
  {
    id: "engraving",
    label: "Engraving (Optional)",
    type: "input-text",
    countStep: true,
    helpTitle: "",
    popupId: "rb-popup-engraving",
    options: {
      maxChars: 20,
      placeholder: "Enter engraving if you feel inspired",
    },
  },
  {
    id: "summary",
    label: "Confirm",
    type: "summary",
    countStep: false,
    helpTitle: "",
  },
];
